import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ResultadoBotPage } from './resultado-bot';

// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    ResultadoBotPage,
  ],
  imports: [
    IonicPageModule.forChild(ResultadoBotPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class ResultadoBotPageModule {}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/resultado-bot/resultado-bot.module.ts